import moment from 'moment';

const DATE_STRING_PATTERNS: RegExp[] = [
  /^\d{4}(\/|-)\d{2}(\/|-)\d{2}$/, // ISO 8601 format AND default format of date string used across the site YYYY/MM/DD,
  /^\d{2}(\/|-)\d{2}(\/|-)\d{4}$/ // MM/DD/YYYY OR MM-DD-YYYY
];
type DateAcceptableValue = Date | string | number;

export const toDateValue = (value: DateAcceptableValue): Date => {
  if (value instanceof Date) {
    return value;
  }

  if (typeof value === 'string') {
    if (isDateString(value)) {
      // date string - should be considered as UTC Date
      return moment(value).utc().toDate();
    }
    // time string - we have offset OR timezone - convert to local under the hood
    return moment(value).toDate();
  }

  return new Date(value);
};

const isDateString = (value: string): boolean => DATE_STRING_PATTERNS.some((dateRegExp: any) => dateRegExp.test(value));
